import script from "./UserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPage.vue?vue&type=script&setup=true&lang=js"

import "./UserPage.vue?vue&type=style&index=0&id=7f41b17a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f41b17a"]])

export default __exports__